import TraceInit from '../TraceInit';

const AdapterConfig = {
  // getTraceData: (traceId) => {
  //   return TraceInit.getInstance().parseConfig.getTraceData(traceId);
  // },

  // TODO: 参数待优化
  getTraceData: (pageName, traceId, params = {}) => {
    return TraceInit.getInstance().parseConfig.getTraceData(pageName, traceId, params);
  },
  getTraceOperation: (traceId) => {
    return TraceInit.getInstance().parseConfig.getTraceOperation(traceId);
  },
  // 参数data是getTraceData得出的结果，isTouch表示是否是点击
  getSpm: (statSend, data, isTouch = false) => {
    return TraceInit.getInstance().parseConfig.getSpm(statSend, data, isTouch);
  },
};

export default AdapterConfig;
